import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as componentTypes from "../../../constants/componentTypes";
import * as navigationActions from "../../../actions/navigationActions";
import * as modelHelper from "../../../helpers/modelHelper";

import imgLoader from "../../../resources/img/loader.svg";

import CancelButton from "../generic/CancelButton";
import Modal from "../generic/Modal";

class LoadingModal extends Component {
    handleCloseModalClick = () => {
        if (this.props.params.onCancel !== null) {
            this.props.dispatchAction(this.props.params.onCancel);
        }

        this.props.dispatchCloseModalAction();
    };

    getModalMessage = () => {
        if (this.props.params.message !== null) {
            return this.props.params.message;
        }

        return "";
    };

    render() {
        return (
            <Modal
                modalId={this.props.id}
                onClose={this.handleCloseModalClick}
                header={modelHelper.buildModalSection(
                    <React.Fragment>
                        <Translate value="welcome.loading" />
                        ...
                    </React.Fragment>
                )}
                content={modelHelper.buildModalSection(
                    <React.Fragment>
                        {this.getModalMessage()}
                        <img alt="loading" src={imgLoader} />
                    </React.Fragment>,
                    "flex-column flex-align-center"
                )}
                footer={modelHelper.buildModalSection(<CancelButton onClick={this.handleCloseModalClick} />)}
            />
        );
    }
}

const mapStoreToProps = () => {
    return {};
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.LOADING_MODAL));
        },
        dispatchAction: (action) => {
            dispatch(action);
        }
    };
};

export default LoadingModal = connect(mapStoreToProps, mapDispatchToProps)(LoadingModal);
